<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="7" :lg="8" :md="9" :sm="24">
            <a-form-item label="基金经理姓名">
              <a-input
                placeholder="请输入基金经理姓名"
                v-model="queryParam.managerName"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />批量删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record.id)">删除</a>
        </span>
      </a-table>
    </div>

    <productsFundManager-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></productsFundManager-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import ProductsFundManagerModal from './add.vue';
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue';
import customRender from '@/utils/customRender.js';
import { deleteById, deleteBatch } from '@/api/investment';
import { postTag } from '../../../api/manage';

export default {
  name: 'ProductsFundManagerList',
  components: {
    JDictSelectTag,
    ProductsFundManagerModal
  },
  data() {
    return {
      description: 'PRODUCTS_FUND_MANAGER管理页面',
      loading: false,
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      queryParam: {
        manaId: '',
        managerName: ''
      },
      dataSource: [],
      selectedRowKeys: [],
      selectionRows: [],
      // 表头
      columns: [
        {
          title: '基金经理姓名',
          align: 'center',
          dataIndex: 'managerName',
          customRender: customRender
        },
        {
          title: '职位',
          align: 'center',
          dataIndex: 'duty',
          customRender: customRender
        },
        {
          title: '简介',
          align: 'center',
          dataIndex: 'managerIntroduction',
          ellipsis: true,
          customRender: customRender
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_PRODUCT + '/product/investment/manager/list',
        delete: process.env.VUE_APP_CMS_PRODUCT + '/product/manager/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT + '/product/manager/deleteBatch'
      }
    };
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取数据
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        pageNo: that.ipagination.current,
        pageSize: that.ipagination.pageSize
      };
      if (this.queryParam.managerName != '') {
        params.managerName = this.queryParam.managerName;
      }
      that.loading = true;
      postTag(this.url.list, params).then(res => {
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.loading = false;
          that.ipagination.total =
            res.result && res.result.total ? res.result.total : 0;
        }
      });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    // 编辑
    handleEdit(record) {
      console.log(record);
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    // 添加
    handleAdd() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        let ids = this.selectedRowKeys.join(',');
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            let formData = new FormData();
            formData.append('ids', ids);
            deleteBatch(formData).then(res => {
              that.loading = false;
              if (res.success) {
                that.$message.success(res.message);
                that.getList();
                that.onClearSelected();
              } else {
                that.$message.error(res.message);
              }
            });
          }
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //删除
    handleDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          let formData = new FormData();
          formData.append('id', id);
          deleteById(formData).then(res => {
            that.loading = false;
            if (res.success) {
              that.getList();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    },
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
